import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "traffic",
  "use": "traffic-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"traffic\"><defs><style>#traffic .cls-1{fill:none;stroke:#3c4859;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px}</style></defs><circle class=\"cls-1\" cx=\"200\" cy=\"200\" r=\"82.77\" /><circle cx=\"200\" cy=\"200\" r=\"10\" fill=\"#3c4859\" /><path class=\"cls-1\" d=\"M200 117.23V84.77M200 315.23v-32.46M282.77 200h32.46M84.77 200h32.46\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol